export const KHAN_ALLIANCE_CAMP_TAUNT_MOVEMENT_TYPE = 20
export const KHAN_ALLIANCE_CAMP_ATTACK_MOVEMENT_TYPE = 21
export const KHAN_TAUNT_MOVEMENT_TYPE = 34
export const KHAN_TAUNT_SOURCE_AREA_TYPE = 35
export const KHAN_HORN_MOVEMENT_TYPES = new Set([
    KHAN_ALLIANCE_CAMP_TAUNT_MOVEMENT_TYPE,
    KHAN_ALLIANCE_CAMP_ATTACK_MOVEMENT_TYPE,
    KHAN_TAUNT_MOVEMENT_TYPE
])

export const isKhanTauntAttack = attack => {
    if (!attack || typeof attack !== 'object')
        return false

    if (attack?.isKhanHorn === true)
        return true

    if (attack?.isKhanTaunt === true)
        return true

    if (KHAN_HORN_MOVEMENT_TYPES.has(Number(attack?.movementType)))
        return true

    return Number(attack?.movement?.sourceAttack?.type) === KHAN_TAUNT_SOURCE_AREA_TYPE
}

export const countKhanTauntAttacks = attacks =>
    (Array.isArray(attacks) ? attacks : []).reduce(
        (sum, attack) => sum + (isKhanTauntAttack(attack) ? 1 : 0),
        0
    )

export const resolveIncomingKhanTauntCount = status => {
    const explicitCount = Number(status?.incomingKhanTauntCount ?? NaN)
    if (Number.isFinite(explicitCount) && explicitCount >= 0)
        return Math.floor(explicitCount)

    return countKhanTauntAttacks(status?.incomingAttacks)
}

export const resolveRecentKhanAttackCount = status => {
    const explicitCount = Number(status?.recentKhanAttackCount ?? NaN)
    if (Number.isFinite(explicitCount) && explicitCount >= 0)
        return Math.floor(explicitCount)

    return countKhanTauntAttacks(status?.recentKhanAttacks ?? status?.recentIncomingAttackers)
}
